<template>
  <div class="dropdown" :class="{ 'dropdown--visible': isActive }">
    <div class="dropdown__inner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.dropdown {
  position: absolute;
  right: -1.1rem;
  top: 100%;
  padding-top: 2.5rem;
  z-index: $zHeader;
  opacity: 0;
  pointer-events: none;
  width: min-content;
  transition: opacity $tr;

  &__inner {
    position: relative;
    padding: 1.5rem 2rem;
    border: 1px solid $cAddLight;
    background-color: $cWhite;
    border-radius: 4px;
    box-shadow: 0 10px 20px rgba(23, 25, 51, 0.1);

    &:before {
      content: '';
      position: absolute;
      transform: rotate(45deg);
      right: 10px;
      top: -7px;
      width: 12px;
      height: 12px;
      background-color: $cWhite;
      border-left: 1px solid $cAddLight;
      border-top: 1px solid $cAddLight;
    }
  }

  &--visible {
    opacity: 1;
    pointer-events: all;
  }
}
</style>
